import { Guarded, route$navigation } from ":setup/qrouter";
import { Route } from "@solidjs/router";
import { Show } from "solid-js";
//
import { checkUserToken, checkPlatformSettings } from "../SHARED/guards";
import { Loader1 } from ":src/components/loaders";
import { global } from ":shared/app";
import { DashboardLayout } from ":src/layouts";

//
import routes from "./routes";
import { account$signout, Profile, account$profile } from ":src/modules/account";
import { livestage$, LiveStage } from ":src/modules/livestage";
import { schedule$agenda, Agenda } from ":src/modules/schedule";
import { FAQInquiry, help_portal$faq_inquiry } from ":src/modules/help-portal";
import {
  learning_portal$resources,
  learning_portal$mentors,
  learning_portal$workshops,
  Resources,
  Mentors,
  Workshops,
} from ":src/modules/learning-portal";
import {
  teaming$my_team,
  teaming$participants,
  teaming$project_submission,
  teaming$exhibition,
  MyTeam,
  Participants,
  ProjectSubmission,
  SubmissionTimer,
  Exhibition,
} from ":src/modules/teaming";

export default function Participant() {
  const baseRoute = routes.BASE;
  return (
    <Guarded
      // options={{ verbose: true }}
      setup={{
        baseRoute,
        guard: {
          steps: [checkUserToken, checkPlatformSettings],
        },
        lockedRoutes: {
          [routes.livestage]: () => global.store.actions.platform.getSettingsFor("live_stage").locked,
          [routes.project_submission]: () => global.store.actions.platform.getSettingsFor("submission").locked,
          [routes.workshops]: () => global.store.actions.platform.getSettingsFor("workshops").locked,
        },
      }}
      components={{
        pageNotFound: () => <div>this is Participant page error, this page doesn't exist</div>,
        layout(props) {
          const { guard } = props;

          return (
            <Show when={!guard.loading()} fallback={<Loader1 subtitle="Participant" msg={guard.msg()} />}>
              <DashboardLayout
                childrenTop={[SubmissionTimer()]}
                sideNav={{
                  setup: {
                    baseRoute,
                  },
                  components: {
                    items: [
                      livestage$.Anchors.Side,
                      schedule$agenda.Anchors.Side,
                      teaming$my_team.Anchors.Side,
                      teaming$participants.Anchors.Side,
                      teaming$project_submission.Anchors.Side,
                      teaming$exhibition.Anchors.Side,
                      learning_portal$mentors.Anchors.Side,
                      learning_portal$resources.Anchors.Side,
                      learning_portal$workshops.Anchors.Side,
                      //
                      () => route$navigation.Elements.Filler(),
                      () => route$navigation.Elements.Divider({ class: "bg-brand" }),
                      //
                      help_portal$faq_inquiry.Anchors.Side,
                      account$profile.Anchors.Side,
                      account$signout.Anchors.Side,
                    ],
                  },
                }}
              >
                <Show when={!guard.locked()} fallback={"This page is currently locked by admin"}>
                  {props.children}
                </Show>
              </DashboardLayout>
            </Show>
          );
        },
      }}
    >
      <Route path={routes.faq_inquiry} component={FAQInquiry} />
      <Route path={[routes.profile, "/"]} component={Profile} />
      {/*  */}
      <Route path={routes.livestage} component={LiveStage} />
      <Route path={routes.resources} component={Resources} />
      <Route path={routes.mentors} component={Mentors} />
      <Route path={routes.participants} component={Participants} />
      <Route path={routes.exhibition} component={Exhibition} />
      <Route path={routes.agenda} component={Agenda} />
      <Route
        path={routes.project_submission}
        component={() => (
          <ProjectSubmission
            onRouteToCreateTeam={() => {
              global.store.actions.route.navigate(routes.myteam);
            }}
          />
        )}
      />
      <Route path={routes.myteam} component={MyTeam} />
      <Route path={routes.workshops} component={Workshops} />
    </Guarded>
  );
}
